<template>
  <div>
    <!---谈判信息------>
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="谈判信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :el-attrs="{ column: 3 }"
            :info="orderInfo"
            :option="options"
          />
        </div>
      </div>
    </div>

    <!---品目信息----->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="品目信息" />
        </div>
        <div class="section-content">
          <purchase-list-supplier
            ref="purchaseList"
            :table-data="orderInfo.itemList"
            :item-schema-list="columnConfig"
          />
        </div>
      </div>
    </div>

    <!----对供应商要求---->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="对供应商要求" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="ruleOptions"
            :el-attrs="{
              size: 'medium',
              column: 4,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          />
        </div>
      </div>
    </div>

    <!-----所有公告---------->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="所有公告" />
        </div>
        <div class="section-content">
          <!--采购公告--->
          <bulletin-item
            v-for="item in noticeList"
            :key="item.noticeId"
            :bulletin-label="item.noticeLabel"
            :title="item.title"
            :content="item.content"
            :release-time="item.releaseTime"
            button-text="查看公告"
            :is-time-norm-day="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import PurchaseListSupplier from '@/components/common/PurchaseListComponent/PurchaseListSupplier.vue'
import BulletinItem from '@/components/common/Bulletins/BulletinItem'

import {
  negotiationV2ProcureTypeDict,
  negotiationV2RequireTaxDict,
  negotiationV2AllowPartDict
} from '@/dictionary/project/negotiation-v2'
import {
  projectTypeDict,
  announcementTypeDict
} from '@/dictionary/project/common'

import { getNegotiationV2DetailApi } from '@/api/supplier/negotiation-v2'
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { cloneDeep } from 'lodash'
import DateUtils from '@/utils/date'

const ruleOptions = [
  {
    label: '报价申请时间',
    prop: '',
    filter: value => DateUtils.getNormMinuteRange(value.offerStartTime, value.offerEndTime),
    elAttrs: { span: 4 }
  },
  { label: '谈判时间', prop: 'negotiateTime', isNormMinute: true },
  {
    label: '采购类型',
    prop: 'purchaseType',
    filter: value => negotiationV2ProcureTypeDict.translate(value).label || '-'
  },
  {
    label: '报价含税',
    prop: 'offerRequireTax',
    filter: value => negotiationV2RequireTaxDict.translate(value).label || '-'
  },
  {
    label: '允许对部分品目报价',
    prop: 'offerAllowPart',
    filter: value => negotiationV2AllowPartDict.translate(value).label || '-'
  }
]

export default {
  components: {
    BaseSectionTitle,
    BulletinItem,
    PurchaseListSupplier
  },

  mixins: [materialColumnMixin],

  props: {
    orderId: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      ruleOptions,
      orderInfo: {},

      options: [
        { label: '采购名称', prop: 'orderName', elAttrs: { span: 3 } },
        { label: '采购单位', prop: 'ownerCompanyName' },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label
        },
        { label: '谈判编号', prop: 'orderCode' },
        {
          label: '谈判地点',
          prop: '',
          filter: value => `${value.province} - ${value.city} - ${value.area}`
        },
        { label: '详细地址', prop: 'address', elAttrs: { span: 2 } }
      ],

      noticeList: []
    }
  },

  created() {
    this.getNegotiationDetail()
  },

  methods: {
    /**
     * 设置品目列表
     */
    getTableConfigList(data = []) {
      return [
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '数量', prop: 'itemNum' },
        { label: '单位', prop: 'unitType' },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '交货地点', prop: 'deliveryAddress', minWidth: 100 },
        { label: '交货时间(天)', prop: 'deliveryDay', minWidth: 120 },
        { label: '备注', prop: 'remarks', minWidth: 100 },
        {
          label: '附件',
          prop: 'fileGroupId',
          slotName: 'fileGroupId',
          minWidth: 160
        }
      ]
    },

    /**
     * 获取招标单详情
     */
    async getNegotiationDetail() {
      try {
        const _data = await getNegotiationV2DetailApi(this.orderId)
        this.orderInfo = _data.data || {}
        const { purchaseNotice, changeNoticeList, closeNotice } = this.orderInfo
        this.columnConfig = cloneDeep(this.orderInfo.itemSchemaList)
        this.orderInfo.itemList = (this.orderInfo.itemList || []).map(item => {
          item.attachmentGroupId = item.fileGroupId
          return item
        })
        this.setSupplierOfferConfig(this.requireTax, true, this.isGanNanHosp)
        this.noticeList = [
          {
            ...purchaseNotice,
            noticeLabel: announcementTypeDict.PURCHASE.label
          }
        ]
        if (changeNoticeList && changeNoticeList.length > 0) {
          changeNoticeList.forEach(el => {
            el.noticeLabel = announcementTypeDict.CHANGE.label
          })
          this.noticeList = [purchaseNotice, ...changeNoticeList]
        }
        if (closeNotice) {
          this.noticeList.push({
            ...closeNotice,
            noticeLabel: announcementTypeDict.FLOW.value
          })
        }
        this.$emit('setOrderName', this.orderInfo.orderName)
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.file-section {
  width: 500px;
}

.project-name {
  text-align: center;
  font-size: pixel-to-rem($n: 26);
  @include text-bold;
  line-height: 1.5;
  padding: pixel-to-rem(20);
  padding-top: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: pixel-to-rem($n: 20);
}

// 公告内容样式
.notice-content {
  h4 {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
